import 'components/onboarding/style.scss';

import { ReactComponent as LogoutIcon } from 'assets/icons/logout.svg';
import { logOut } from 'services/authService';
import { FormProvider, useForm } from 'react-hook-form';
import { OnboardForm } from './form-components/organization-fields';
import { IRegisterOrganization } from 'interface/organizationInterface';
import { createOrganization } from 'services/organizationService';
import './style.scss';
import { setOrganization } from 'redux-setup/slices/organizationSlice';
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks';
import { toast } from 'react-toastify';
import { useCallback, useState } from 'react';
import { RootState } from 'redux-setup/store';
import { GithubLink } from './form-components/github-link';

const Onboarding = () => {
  const dispatch = useAppDispatch();
  const isOnboarding = useAppSelector(
    (state: RootState) => state.user.isOnboarding,
  );
  const [step, setStep] = useState<number>(isOnboarding ? 0 : 1);

  const onboardForm = useForm<IRegisterOrganization>({
    defaultValues: {
      Name: '',
    },
  });

  const handleClick = () => {
    logOut();
  };

  const onSubmit = async (data: IRegisterOrganization) => {
    try {
      const response = await createOrganization({
        Name: data.Name,
      });

      if (response.status !== 200) {
        toast.error('Error creating organization, please try again later.');
        console.error('Error creating organization:', response);
        return;
      }

      dispatch(
        setOrganization({ id: String(response.data.ID), name: data.Name }),
      );
      setStep(1);
    } catch (error) {
      toast.error('Network error, please try again later.');
      console.error('Error creating organization:', error);
    }
  };

  const renderStepper = useCallback(
    (step: number) => {
      switch (step) {
        case 0:
          return (
            <form onSubmit={onboardForm.handleSubmit(onSubmit)}>
              <FormProvider {...onboardForm}>
                <OnboardForm />
              </FormProvider>
            </form>
          );
        case 1:
          return <GithubLink />;
        default:
          return <div>No Step</div>;
      }
    },
    [step],
  );

  return (
    <div className="onboarding-container">
      <div className="onboarding-content">
        <div className="form-group">{renderStepper(step)}</div>

        <div
          className="mt-10 logout_popup flex justify-center gap-3 cursor-pointer"
          onClick={handleClick}>
          <LogoutIcon />
          Go Back
        </div>
      </div>
    </div>
  );
};

export default Onboarding;
